<template>
  <!-- 客户账单管理 -->
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            @reset="handleReset"
            trackCode='baibuBillBillList-1'
          >
            <template slot="batch-search-btn">
              <el-button type="primary" :size="formSize" :loading="loading" @click="handleBatchSearch()">
                批量查询
              </el-button>
            </template>
          </jr-search2>
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList" />
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="tableColumn"
        >
          <template #downloadButton="{row}">
            <page-export-button
              buttonText="下载"
              exportType="button"
              exportServe="fin_ap_bill_export"
              :total="total"
              :isLimit="true"
              :exportParams="{ billNo: row.billNo || '' }"
              trackCode='baibuBillBillList-4'
              :buttonClass="['table-button', 'table-button-primary']"
              plain
              buttonType="default"
            />
          </template>
        </jr-table>
      </template>
      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
    <!-- 批量搜索 -->
    <batch-search
      :visible.sync="isBatchSearchShow"
      :type-list="batchSearchTypeList"
      :loading="loading"
      @confirm="handleBatchSearchConfirm"
      trackCode='baibuBillBillList-2'
    />
    <!-- 详情 -->
    <detail
      v-if="isDetailShow"
      :visible.sync="isDetailShow"
      :detailInfo="detailInfo"
      :billNo="detailInfo.billNo"
      @operate-success="getList"
    />
    <!-- 调账 -->
    <account-adjustment-dialog
      :visible.sync="isAccountAdjustmentShow"
      :detailInfo="accountAdjustmentInfo"
      :billNo="accountAdjustmentInfo.billNo"
      @isSetBill="handleIsSetBill"
    />
  </div>
</template>

<script>
import { getBillList } from '@/api/baibu-bill';
import { setStatusColor } from '@/filters/index';
import detail from './components/detail';
import accountAdjustmentDialog from './components/account-adjustment-dialog';

const queryFormDefault = {
  timeType: '1', // 时间类型
  page: 1,
  limit: 20,
  billStatus: '', // 账单状态: NOT_REPAID 未回款,PARTIALLY_REPAID 部分回款,FULLY_REPAID 已回款
  cityNo: '', // 归属城市
  searchContent: '', // 搜索内容-不支持模糊查询,批量查询时以逗号分隔
  searchType: '1', // 搜索类型：1-客户名称,2-客户编号

  searchBatchContent: '', // 处理批量查询时-搜索内容
  searchBatchType: '1', // 处理批量查询时-搜索类型
};

export default {
  name: 'BaibuBillBillList',
  components: { detail, accountAdjustmentDialog },
  data() {
    const optionsList = [
      { value: '1', label: '客户名称' },
      { value: '2', label: '客户编号' },
    ];
    return {
      loading: false,
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      formList: [
        {
          prop: 'searchType',
          contentProp: 'searchContent',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: optionsList,
        },
      ],
      selectList: [
        {
          title: '账单状态',
          prop: 'billStatus',
          dictionaryPath: '/finance/finance-receipt/ApBillStatusEnum',
        },
        {
          title: '归属城市',
          prop: 'cityNo',
          dictionaryPath: '/finance/finance-receipt/CreditCity',
        },
      ],
      tableColumn: [
        {
          prop: 'billName',
          label: '账期',
          minWidth: '1',
          disabled: true,
          trackCode: 'baibuBillBillList-5',
          click: (row) => this.handleDetail(row),
          show: () => this.$has('BBZQGL-KHZDGL-XQ'),
        },
        { prop: 'businessName', label: '客户名称', minWidth: '1' },
        { prop: 'businessNo', label: '客户编号', minWidth: '1' },
        { prop: 'cityName', label: '归属城市', minWidth: '1' },
        { prop: 'billAmount', label: '账期金额(元)', filterName: 'toFenThousandsAndFloat' },
        { prop: 'receiptCount', label: '总支用笔数', minWidth: '1' },
        { prop: 'refundCount', label: '总退款笔数', minWidth: '1' },
        { prop: 'noRepaymentAmount', label: '未回款金额(元)', filterName: 'toFenThousandsAndFloat' },
        // 账单状态: NOT_REPAID 未回款,PARTIALLY_REPAID 部分回款,FULLY_REPAID 已回款
        { label: '账单状态', status: 'billStatus', statusDesc: 'billStatusDesc', statusColor: (val) => setStatusColor(val, 'baibuBillStatus') },
        {
          label: '操作',
          prop: 'operate',
          width: '125px',
          disabled: true,
          btnGroups: [
            {
              name: '调账',
              plain: true,
              className: ['table-button', 'table-button-primary'],
              trackCode: 'baibuBillBillList-3',
              showBtn: (row) => this.$has('BBZQGL-KHZDGL-TZ') && row.billStatus === 'NOT_REPAID',
              click: (row) => this.handleOperateState(row),
            },
            {
              name: '下载',
              plain: true,
              className: ['table-button', 'table-button-primary'],
              trackCode: 'baibuBillBillList-4',
              showBtn: () => this.$has('BBZQGL-KHZDGL-XZ'),
              btnSlotName: 'downloadButton',
            },
          ],
        },
      ],
      /** ------批量搜索开始---- */
      // 批量搜索搜索条件集合
      batchSearchTypeList: [
        { value: '2', label: '客户编号' },
      ],
      isBatchSearchShow: false, // 批量搜索
      batchResults: {}, // 批量操作返回结果
      isBatch: false, // 是否是批量操作
      /** ------批量搜索结束---- */

      /** ------详情---- */
      isDetailShow: false,
      detailInfo: {},

      /** ------调账---- */
      isAccountAdjustmentShow: false,
      accountAdjustmentInfo: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 是否调账
    handleIsSetBill(isSetBill) {
      if (isSetBill) {
        this.getList();
      }
    },
    // 打开调账弹窗
    handleOperateState(row) {
      this.accountAdjustmentInfo = row || {};
      this.isAccountAdjustmentShow = true;
    },
    // 详情弹窗
    handleDetail(row) {
      this.detailInfo = row || {};
      this.isDetailShow = true;
    },
    // 批量查询提交
    handleBatchSearchConfirm(form) {
      const param = JSON.parse(JSON.stringify(queryFormDefault));
      param.searchBatchType = form.searchType || '';
      param.searchBatchContent = (form.list || []).join(',');
      this.queryForm = { ...param };
      this.getList(true);
    },
    // 批量查询弹窗
    handleBatchSearch() {
      this.isBatchSearchShow = true;
    },
    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.getList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    // 处理提交接口的参数（列表/导出）
    newAPiParam() {
      const params = JSON.parse(JSON.stringify(this.queryForm));
      // 批量查询条件处理
      if (this.isBatch) {
        params.searchContent = params.searchBatchContent || '';
        params.searchType = params.searchBatchType || '';
      }
      delete params.timeType;
      delete params.searchBatchContent;
      delete params.searchBatchType;
      return params;
    },
    // 列表接口请求
    async getList(batch = false) {
      try {
        this.isBatch = batch;
        const params = this.newAPiParam();
        this.loading = true;
        this.list = [];
        const res = await getBillList(params);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
        this.isBatchSearchShow = false; // 批量搜索弹窗关闭
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.list = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .btn-group {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
